import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-252">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-burgundy-950/80 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-253" />

      {/* Modal */}
      <div className="relative bg-cream-50 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden animate-fade-in-up" data-id="element-254">
        {/* Header */}
        <div className="sticky top-0 bg-cream-50 border-b border-cream-200 px-6 py-4 flex items-center justify-between" data-id="element-255">
          <h2 className="text-2xl font-serif font-bold text-burgundy-900" data-id="element-256">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-cream-200 transition-colors text-burgundy-600 hover:text-burgundy-900" aria-label="Cerrar" data-id="element-257">
            <X className="w-5 h-5" data-id="element-258" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-259">
          {children}
        </div>
      </div>
    </div>;
}